/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $timeout,
  webpage,
  eventService,
  messageService,
  messagesService,
  actionService,
  mergeFieldsService,
  labelsService,
  LabelType
) => {
  $scope.Model = {
    availableLabels: [],
    availableMessages: [],
    mergeFields: [],
    messagesList: null,
    watcher: null,
    isArchive: false,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  const loadMessages = () => {
    webpage.pageTitle('Loading, please wait');
    messagesService
      .getAvailable({ type: ['email', 'sms'], isActive: !$scope.Model.isArchive })
      .then((messages) => {
        webpage.pageTitle('External Notifications : Settings');
        $timeout(() => {
          $scope.Model.availableMessages = messages;
          $scope.Model.isReady = true;
        });
      });
  };

  const loadLabels = () =>
    labelsService
      .getAvailable({
        orderBy: 'name',
        coerceTo: 'string',
        isDescending: false,
        isActive: true
      })
      .then((labels) => {
        $scope.Model.availableLabels = _.filter(
          labels,
          (l) => l.type.name === LabelType.file.name
        );
        loadMessages();
      });

  const loadMergeFields = () => {
    const deferred = $q.defer();
    mergeFieldsService.getFields(false).then((data) => {
      $scope.Model.mergeFields = data;
      deferred.resolve(data);
    });
    return deferred.promise;
  };

  if ($rootScope.CurrentAccount.isAdministrator) {
    loadMergeFields().then(() => {
      loadLabels();
    });
  }

  /*
   * Events available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.$on('messageDelete', () => {
    messagesService.clearCache();
    actionService.deleteDocuments(
      $scope.Model.messagesList.getSelected(),
      messageService.deleteMessage,
      $scope.Model.messagesList.removeData,
      'external notification(s)'
    );
  });

  $scope.$on('messageDuplicate', () => {
    messagesService.clearCache();
    actionService.duplicateDocuments(
      $scope.Model.messagesList.getSelected(),
      messageService.readMessage,
      messageService.createMessage,
      $scope.Model.messagesList.setDataAppend,
      'name',
      ' copy',
      'external notification(s)'
    );
  });

  $scope.$on('messageActivate', () => {
    messagesService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.messagesList.getSelected(),
      messageService.updateMessage,
      $scope.Model.messagesList.removeData,
      'external notification(s)',
      true
    );
  });

  $scope.$on('messageArchive', () => {
    messagesService.clearCache();
    actionService.toggleDocuments(
      $scope.Model.messagesList.getSelected(),
      messageService.updateMessage,
      $scope.Model.messagesList.removeData,
      'external notification(s)',
      false
    );
  });

  $scope.$on('messageAdd', (e, $event) => {
    messagesService.clearCache();
    eventService.messageEdit({
      event: $event,
      message: null,
      mergeFields: $scope.Model.mergeFields
    });
  });

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.messageEdit = ($event, message) => {
    eventService.messageEdit({
      event: $event,
      message,
      mergeFields: $scope.Model.mergeFields
    });
  };

  $scope.messageEdited = (messageToEdit) => {
    const message = messageToEdit;
    messagesService.clearCache();
    if (message.isNew === true) {
      delete message.isNew;
      if (message.isActive !== $scope.Model.isArchive) {
        $scope.Model.messagesList.setDataAppend(message);
      }
    } else {
      $scope.Model.messagesList.setDataReplace(message);
    }
  };

  $scope.messageLabelsSelect = ($event, message) => {
    eventService.dialogLabelSelect({
      event: $event,
      labels: $scope.Model.availableLabels,
      selectedLabels: message.idLabels,
      data: message
    });
  };

  $scope.messageLabelsSelected = (selectedLabels, messageToSelected) => {
    const message = messageToSelected;
    message.idLabels = selectedLabels;
    messagesService.clearCache();
    $scope.Model.messagesList.setDataReplace(message);
    messageService.updateMessage(message);
  };

  $scope.listChange = (list, data, isSelected) => {
    $scope.$parent.Model.childStateHasSelection = isSelected || list.isSelectedAny();
  };

  $scope.listReady = (list) => {
    $scope.Model.messagesList = list;
    $scope.Model.watcher = $scope.$parent.$watch(
      'Model.childStateIsArchive',
      (newValue, oldValue) => {
        if (newValue !== oldValue) {
          $scope.Model.isArchive = newValue;
          $scope.Model.isReady = false;
          $scope.Model.watcher();
          loadMessages();
        }
      }
    );
  };
};
